import { getRouteProperties } from './analyticsConfig.js';

const placements = new Set(['desktop_navigation', 'mobile_navigation', 'hero']);

export const createSignupClickHandler = (getPathname, capture) => (event) => {
  // Enter creates a click. Middle-click creates auxclick, not a second click.
  if (event.type === 'click' ? event.button !== 0 : event.type !== 'auxclick' || event.button !== 1) return;
  const link = event.target?.closest?.('a[data-signup-cta]');
  const placement = link?.getAttribute('data-signup-cta');
  const route = getRouteProperties(getPathname());
  if (!route || !placements.has(placement)) return;
  try {
    // Dynamic article slugs collapse to a fixed template. Never capture destinations or text.
    capture({ pathname: route.route_template, route_template: route.route_template, placement });
  } catch {
    // Link navigation must work even when capture fails.
  }
};
